import axios from 'axios'

const API_URL = import.meta.env?.VITE_API_URL || 'http://localhost:3000'

const api = axios.create({ baseURL: API_URL })

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      if (!window.location.pathname.includes('/login-page')) {
        window.location.href = '/login-page'
      }
    }
    return Promise.reject(error)
  }
)

export default api
